export function validateUsername(name: string): boolean {
    return /^(\w|\.| (?! )){2,32}$/.test(name);
}
